import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import { confirmAlert } from 'react-confirm-alert';

//components
import withLocalization from '~/hoc/withLocalization';

//elements
import GenericList from '~/components/GenericList/GenericList';
import Button from '~/components/CustomButton/CustomButton.jsx';
import RequiredStar from '../../../elements/RequiredStar';

//assets
import CloseModalIcon from '~/assets/img/CloseApproveModalIcon.svg';

const EMPTY_FILTERS = {};

class F5PlacementsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listKey: 0,
            actionInProgress: null,
            cancelRow: null,
            cancelDescription: '',
        };
    }

    requestData = ({ pagesize, page }) => {
        const { rosterStore } = this.props;
        return rosterStore.getClientFCodePlacements({ fcode: 'F5', page, pagesize });
    };

    handleAction = async (row, action, description) => {
        const { rosterStore } = this.props;
        this.setState({ actionInProgress: row.id });
        try {
            await rosterStore.updateFCodePlacement(row.id, { action, description });
            this.setState(prev => ({ listKey: prev.listKey + 1, cancelRow: null, cancelDescription: '' }));
        } finally {
            this.setState({ actionInProgress: null });
        }
    };

    closeCancelDialog = () => this.setState({ cancelRow: null, cancelDescription: '' });

    getColumns() {
        const { t } = this.props;
        const { actionInProgress } = this.state;

        return [
            {
                Header: 'Employee',
                id: 'user_name',
                accessor: row => row.user_name,
                isSortable: false,
                minWidth: 150,
            },
            {
                Header: 'Cycle Period',
                id: 'cycle_period',
                accessor: row => row.cycle_start_date && row.cycle_end_date
                    ? `${moment(row.cycle_start_date).format('DD MMM YYYY')} – ${moment(row.cycle_end_date).format('DD MMM YYYY')}`
                    : '—',
                isSortable: false,
                minWidth: 180,
            },
            {
                Header: 'Holiday (F1 Date)',
                id: 'trigger_date',
                accessor: row => moment(row.trigger_date).format('ddd D MMM YYYY'),
                isSortable: false,
                minWidth: 150,
            },
            {
                Header: 'F5 Placement Date',
                id: 'placement_date',
                accessor: row => row.placement_date ? moment(row.placement_date).format('ddd D MMM YYYY') : '—',
                isSortable: false,
                minWidth: 150,
            },
            {
                Header: 'Status',
                id: 'status',
                accessor: row => (
                    <div className={`status-block status-${row.status}`}>
                        {t(row.status === 'approved' ? 'Approved' : row.status === 'cancelled' ? 'Cancelled' : 'Pending')}
                    </div>
                ),
                isSortable: false,
                width: 100,
            },
            {
                Header: 'Action',
                id: 'action',
                accessor: row => {
                    const isLoading = actionInProgress === row.id;

                    if (row.status === 'cancelled') return null;

                    if (row.status === 'approved') {
                        return (
                            <Button
                                md
                                disabled={isLoading}
                                onClick={() => confirmAlert({
                                    title: t('Are you sure?'),
                                    message: t('Do you want to reset this F5 placement?'),
                                    buttons: [
                                        { label: t('Yes'), onClick: () => this.handleAction(row, 'reset') },
                                        { label: t('No'), onClick: () => {} },
                                    ],
                                })}
                            >
                                {isLoading ? t('Resetting…') : t('Reset')}
                            </Button>
                        );
                    }

                    if (!row.placement_date) {
                        return (
                            <Button
                                md
                                bsStyle="danger"
                                disabled={isLoading}
                                onClick={() => this.setState({ cancelRow: row, cancelDescription: '' })}
                            >
                                {isLoading ? t('Cancelling…') : t('Cancel')}
                            </Button>
                        );
                    }

                    return (
                        <Button
                            md fill
                            disabled={isLoading}
                            onClick={() => confirmAlert({
                                title: t('Are you sure?'),
                                message: t('Do you want to approve this F5 placement?'),
                                buttons: [
                                    { label: t('Yes'), onClick: () => this.handleAction(row, 'approve') },
                                    { label: t('No'), onClick: () => {} },
                                ],
                            })}
                        >
                            {isLoading ? t('Approving…') : t('Approve')}
                        </Button>
                    );
                },
                isSortable: false,
                width: 110,
            },
        ];
    }

    render() {
        const { show, handleClose, t } = this.props;
        const { listKey, cancelRow, cancelDescription, actionInProgress } = this.state;
        const isCancelling = cancelRow && actionInProgress === cancelRow.id;

        return (
            <>
                <Modal size="xl" centered show={show} onHide={handleClose}>
                    <Modal.Header className="set_ModalHeader">
                        <Modal.Title className='w-100 text-center custom-modal-title'>
                            {t('F5 — Erstatningsfridag (Replacement Rest Days)')}
                        </Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            onClick={handleClose}
                            alt="close"
                        />
                    </Modal.Header>
                    <Modal.Body>
                        <GenericList
                            key={listKey}
                            columns={this.getColumns()}
                            requestData={this.requestData}
                            pageSize={20}
                            filters={EMPTY_FILTERS}
                        />
                    </Modal.Body>
                </Modal>

                <Modal size="md" centered show={!!cancelRow} onHide={this.closeCancelDialog}>
                    <Modal.Header className="set_ModalHeader">
                        <Modal.Title className='w-100 text-center custom-modal-title'>
                            {t('Cancel F5')}
                        </Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            onClick={this.closeCancelDialog}
                            alt="close"
                        />
                    </Modal.Header>
                    <Modal.Body>
                        <p className="mb-2">
                            {t('Reason for cancellation')}<RequiredStar />
                        </p>
                        <textarea
                            autoFocus
                            className="form-control input-block__base-input input-block__base-input_textarea"
                            rows={3}
                            value={cancelDescription}
                            onChange={e => this.setState({ cancelDescription: e.target.value })}
                            placeholder={t('Enter reason…')}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.closeCancelDialog}>{t('Back')}</Button>
                        <Button
                            fill
                            disabled={!cancelDescription.trim() || isCancelling}
                            onClick={() => this.handleAction(cancelRow, 'cancel', cancelDescription.trim())}
                        >
                            {isCancelling ? t('Cancelling…') : t('Cancel Placement')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default withLocalization(F5PlacementsModal);
